import { metadataCatalogGuard } from '@partners/catalog';
import { ContextBuilder } from '../http';

export const provideMetadataCatalogGuard = (): (() => Promise<boolean>) => {
  return async () => {
    const context = new ContextBuilder().addUrlModifiers({ omitProcess: true }).build();
    return await metadataCatalogGuard({ context });
  };
};
